import { getRequest, postRequest } from '../../../../utils/httpRequest'
import { URL } from '../../../../config'

export const getSeasonWeeks = function(seasonId) {
  // console.log('getSeasonWeeks seasonId', seasonId)
  const seasonURL = URL.season
  const url = `${seasonURL}/${seasonId}/weeks`
  const request = getRequest(url)
  return request
}

export const uploadRankingPoints = function(rankingfile) {
  const season = rankingfile.get("season")
  const tier = rankingfile.get("tier")
  // console.log('uploadRankingPoints season, tier', season, tier)
  const seasonURL = URL.season
  const url = `${seasonURL}/${season}/${tier}/uploadwhatifranking`
  const request = postRequest(url,rankingfile)
  return request
}

export const runRankings = function(seasonYear) {
  console.log('uploadRankingPoints seasonYear',seasonYear)
  const seasonURL = URL.season
  const url = `${seasonURL}/${seasonYear}/runwhatifranking`
  const request = postRequest(url)
  return request
}

export const getRankings = function(season, week,gender ) {
  // console.log('uploadRankingPoints season, tier', season, tier)
  const seasonURL = URL.season
  const url = `${seasonURL}/${season}/whatifrankings/${week}/${gender}`
  const request = getRequest(url)
  return request
}


// WEBPACK FOOTER //
// ./src/components/pages/Ranking/api/index.js